module.exports = __webpack_public_path__ + "static/media/trash.43f0e533.svg";